import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import login_auth from "../../Assets/Projects/login_auth.png";
import task from "../../Assets/Projects/task.png";
import shiftScheduler from "../../Assets/Projects/shiftScheduler.png";
import farm from "../../Assets/Projects/farm.png";
import todo from "../../Assets/Projects/todo.png";
import hospital from "../../Assets/Projects/hospital.png";
import schedule from "../../Assets/Projects/schedule.png";
import cashfusion from "../../Assets/Projects/Money income-amico.png";
import money from "../../Assets/Projects/Banknote-bro.png";

const projectsData = [
  {
    imgPath: money,
    title: "Expense Tracker Application",
    description:
      "A comprehensive expense tracking application built with React, Tailwind CSS, and GraphQL. The app allows users to manage and monitor their financial transactions, providing an intuitive interface for tracking expenses and income. GraphQL integration enables efficient data management and real-time updates.",
    ghLink: "https://github.com/colinmarklubembe/graphql-expense-tracker-app",
    demoLink: "https://graphql-expense-tracker-app.onrender.com/",
  },
  {
    imgPath: task,
    title: "Task Management System",
    description:
      "A simple task management system built with react and Javascript",
    ghLink: "https://github.com/colinmarklubembe/task-management-system",
    demoLink: "https://task-management-system-dun-iota.vercel.app/",
  },
  {
    imgPath: cashfusion,
    title: "Cash Fusion",
    description:
      "Cash Fusion is an intuitive petty cash requisition system designed to streamline cash request and approval workflows. Users can easily create, track, and manage requests, with features like approval tracking, detailed reporting, and transaction history. The front-end is built using React, TypeScript, and Tailwind CSS for a responsive and modern user experience. The back-end is powered by Node.js and Express.js, ensuring efficient and secure processing. You can explore the live demo using the demo link",
    ghLink:
      "https://github.com/colinmarklubembe/petty-cash-requisition-system-frontend",
    demoLink: "https://cashfusion-v1.vercel.app/",
  },
  {
    imgPath: login_auth,
    title: "Login Signup Auth",
    description:
      "Fully functional authentication for log in, signup, change password, reset password, invite user. It is written in NodeJS, expressJs, typescript. You can demo it by using the url in the demo link",
    ghLink: "https://github.com/colinmarklubembe/login-signup-auth",
    demoLink: "https://login-signup-auth-2456.onrender.com",
  },
  {
    imgPath: farm,
    title: "Farm Management System",
    description:
      "This is a system that enables farm owners to manage their livestock, poultry and even manage their sales, profitability, cost of maintenance and more. This application is built with plain PHP without any frameworks.",
    ghLink: "https://github.com/colinmarklubembe/farm_management_app-php",
  },
  {
    imgPath: todo,
    title: "Todo App",
    description:
      "This is a basic TODO application that handles the basic CRUD functions of create, update, delete and read todo items in a list. It uses mongoDB as the database service.",
    ghLink: "https://github.com/colinmarklubembe/todo-app-mongodb-frontend",
    demoLink: "https://colinmarktodoapp.netlify.app/",
  },
  {
    imgPath: shiftScheduler,
    title: "Shift Scheduler App - Python",
    description:
      "This is a program that enables shift assignment for a given number of selected members.",
    ghLink:
      "https://github.com/colinmarklubembe/timetable-workshift-scheduler-python",
  },
  {
    imgPath: hospital,
    title: "Hospital Management System",
    description:
      "Used Laravel, a PHP framework to build a hospital management system.",
    ghLink: "https://github.com/colinmarklubembe/hospital-management-system",
  },
  {
    imgPath: schedule,
    title: "Shift Scheduler App - React",
    description:
      "This is a modification to the program written in python. It adds functionality to the application by enabling the download of the shift timetable as a pdf.",
    ghLink: "https://github.com/colinmarklubembe/shift-scheduler-react",
    demoLink: "https://shift-scheduler-app.vercel.app/",
  },
];

const Projects = () => {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {projectsData.map((project, index) => (
            <Col md={4} className="project-card" key={index}>
              <ProjectCard
                imgPath={project.imgPath}
                isBlog={false}
                title={project.title}
                description={project.description}
                ghLink={project.ghLink}
                demoLink={project.demoLink}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
};

export default Projects;
